import React from 'react';
import { connect } from 'react-redux';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import HelpIcon from '@material-ui/icons/Help';
import FormHelperText from '@material-ui/core/FormHelperText';
import uuid from 'uuid/v1';
import { useStyles } from './styles';
import {validate} from './validate'

import {
  ExpansionPanelWrapper,
  FormActionButtons,
  CustomDateRangePicker,
  Input,
  PopoverWrapper
} from 'components';

const initialValues = {
  rentedOutList: []
};

const RentedOutDates = ({ handleSubmit, setSubmitButton, isUpdate}) => {
  const classes = useStyles();
  const [t] = useTranslation();

 

  const onAddHandler = fields => {
    const newId = uuid();
    const newItem = {
      id: newId,
      dateRange: {
        startDate: moment(),
        endDate: moment()
      },
      numberOfUnits: 0
    };
    fields.push(newItem);
  };

  const getTitle = () => {
    return 'Select Out Of Order Dates Period';
  };

  const renderRentedOutItem = (field, index, meta) => {


    return (
      <div className={classes.container}>
        <div className={classes.row}>
          <div className={classes.datePickerWrapper}>
            <Field
              name={`${field}.dateRange`}
              label="Select Dates"
              component={CustomDateRangePicker}
              rentedOut
            />
          </div>

          <div className={classes.inputRow}>
            <Field
              name={`${field}.numberOfUnits`}
              label="Units *"
              isOnlyNumber={true}
              maxLength={9}
              placeholder="0"
              component={Input}
            />
            <PopoverWrapper text="Number of rental units all ready booked during this period.">
              <HelpIcon className={classes.helpIcon} />
            </PopoverWrapper>
          </div>
        </div>

        {meta.submitFailed && meta.error && meta.error[index] && (
          <FormHelperText error>{t(meta.error[index])}</FormHelperText>
        )}
      </div>
    );
  };

  return (
    <div className={classes.wrapper}>
      <Typography variant="h1" className={classes.title}>
        {t('Out Of Order Dates')}
      </Typography>
      <form onSubmit={handleSubmit}>
        <FieldArray
          name="rentedOutList"
          component={ExpansionPanelWrapper}
          isAddDeleteActions={true}
          add={onAddHandler}
          getTitle={getTitle}
          tabName="rented out period"
          tabNameAll="all rented out periods"
          deleteDescription={t(
            'This will permanently delete the rented out period.'
          )}
          children={renderRentedOutItem}
        />
        <FormActionButtons
          cancelPath="/accommodations-and-activities"
          actionLabel="Next"
          setSubmitButton={setSubmitButton}
          isUpdate={isUpdate}
        />
      </form>
    </div>
  );
};

export default reduxForm({
  form: 'rentedOutDatesForm',
  destroyOnUnmount: false, 
  forceUnregisterOnUnmount: false,
  touchOnBlur: false,
  initialValues,
  validate,
  enableReinitialize: true
})((RentedOutDates));
